import { openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, toDisplayString as _toDisplayString, renderSlot as _renderSlot, createVNode as _createVNode, resolveComponent as _resolveComponent, withModifiers as _withModifiers, renderList as _renderList, Fragment as _Fragment, vShow as _vShow, withDirectives as _withDirectives, createTextVNode as _createTextVNode, vModelText as _vModelText, resolveDirective as _resolveDirective, withScopeId as _withScopeId, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"
import _imports_0 from '@/app/ui/assets/svg/ics_o_search_gray.svg'
import _imports_1 from '@/app/ui/assets/svg/x-circle-outline-gray.svg'
import _imports_2 from '@/app/ui/assets/svg/plus.svg'
import _imports_3 from '@/app/ui/assets/svg/x-circle-outline.svg'
import _imports_4 from '@/app/ui/assets/svg/check-circle-border-green.svg'
import _imports_5 from '@/app/ui/assets/svg/pencil-alt.svg'
import _imports_6 from '@/app/ui/assets/svg/exclamation-triangle-red.svg'

const _withId = /*#__PURE__*/_withScopeId("data-v-f224eca2")

_pushScopeId("data-v-f224eca2")
const _hoisted_1 = {
  key: 0,
  ref: "pseudoInput",
  class: "absolute pointer-events-none",
  style: {"opacity":"0"}
}
const _hoisted_2 = { class: "pl-3 pr-2" }
const _hoisted_3 = {
  key: 0,
  class: "text-12px text-gray-lp-600"
}
const _hoisted_4 = {
  key: 0,
  src: _imports_0,
  class: "w-4.5 h-4.5 max-w-none mr-2",
  alt: "search-icon"
}
const _hoisted_5 = {
  key: 1,
  class: "flex"
}
const _hoisted_6 = {
  key: 2,
  class: "flex"
}
const _hoisted_7 = { key: 1 }
const _hoisted_8 = {
  key: 0,
  class: "flex-grow-0"
}
const _hoisted_9 = { class: "px-4 flex flex-col space-y-2" }
const _hoisted_10 = {
  key: 0,
  class: "py-4 px-2 mb-2 text-gray-lp-300 flex justify-center text-center items-center"
}
const _hoisted_11 = {
  key: 0,
  src: _imports_1,
  class: "w-8",
  alt: "x-circle-outline-gray"
}
const _hoisted_12 = { key: 1 }
const _hoisted_13 = {
  key: 1,
  class: "px-4 py-3 border-t"
}
const _hoisted_14 = { class: "gap-x-2 justify-center items-center flex" }
const _hoisted_15 = /*#__PURE__*/_createVNode("img", {
  src: _imports_2,
  alt: "plus"
}, null, -1)
const _hoisted_16 = { class: "flex items-center" }
const _hoisted_17 = { class: "w-4/12" }
const _hoisted_18 = { class: "flex w-2/12" }
const _hoisted_19 = { class: "flex items-center mt-2" }
const _hoisted_20 = { class: "w-4/12" }
const _hoisted_21 = /*#__PURE__*/_createVNode("div", { class: "w-1/12" }, null, -1)
const _hoisted_22 = {
  key: 1,
  class: "flex items-center justify-between"
}
const _hoisted_23 = { class: "w-3/12" }
const _hoisted_24 = { class: "inline-flex gap-x-2 ml-2 w-1/12" }
const _hoisted_25 = {
  key: 2,
  class: "px-4 py-3 border-t"
}
const _hoisted_26 = /*#__PURE__*/_createVNode("span", { class: "gap-x-2 justify-center items-center flex" }, [
  /*#__PURE__*/_createVNode("img", {
    src: _imports_2,
    alt: "plus"
  }),
  /*#__PURE__*/_createTextVNode(" Tambah Rekening Bank ")
], -1)
const _hoisted_27 = /*#__PURE__*/_createVNode("span", { class: "gap-x-2 justify-center items-center flex" }, [
  /*#__PURE__*/_createVNode("img", {
    src: _imports_5,
    alt: "pencil-alt"
  }),
  /*#__PURE__*/_createTextVNode(" Edit No. Rekening ")
], -1)
const _hoisted_28 = {
  key: 1,
  class: "text-12px text-red-lp-1000 mt-2"
}
const _hoisted_29 = {
  key: 0,
  src: _imports_6,
  class: "w-4.5 max-w-none",
  alt: "exclamation-triangle-red"
}
_popScopeId()

export const render = /*#__PURE__*/_withId((_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) => {
  const _component_Icons = _resolveComponent("Icons")!
  const _component_Skeleton = _resolveComponent("Skeleton")!
  const _component_ErrorMessage = _resolveComponent("ErrorMessage")!
  const _directive_click_outside = _resolveDirective("click-outside")!

  return _withDirectives((_openBlock(), _createBlock("div", {
    id: `dropdown-input-${_ctx.idInput}`,
    class: 
      `${_ctx.customWidth} inline-block relative bottom-0 left-0 text-12px xxl:text-14px`
    
  }, [
    (_ctx.isFirstInput)
      ? (_openBlock(), _createBlock("input", _hoisted_1, null, 512))
      : _createCommentVNode("", true),
    _createVNode("div", {
      class: 
        `w-full ${
          _ctx.isOpenMenu && !_ctx.isDisabled && _ctx.isShowErrorMessage
            ? 'border-l border-t border-r rounded-t'
            : `border ${
                _ctx.customBorderRadiusInput ? _ctx.customBorderRadiusInput : 'rounded-md'
              }`
        } ${
          !_ctx.isLoading && _ctx.isShowErrorIndicator
            ? 'border-red-lp-1200'
            : 'border-gray-lp-400'
        } text-black-lp-300 py-2.5 ${
          _ctx.disabledBackground ? 'bg-gray-lp-1500' : ''
        } ${_ctx.customClassInput}`
      
    }, [
      _createVNode("div", _hoisted_2, [
        (_ctx.titleInside)
          ? (_openBlock(), _createBlock("span", _hoisted_3, _toDisplayString(_ctx.titleInside), 1))
          : _createCommentVNode("", true),
        _createVNode("div", {
          class: 
            `flex flex-row flex-nowrap relative w-full ${
              _ctx.isViewAll ? '' : 'pr-5'
            }`
          
        }, [
          (_ctx.isSearchIcon)
            ? (_openBlock(), _createBlock("img", _hoisted_4))
            : _createCommentVNode("", true),
          (_ctx.$slots['selected-prefix'])
            ? (_openBlock(), _createBlock("div", _hoisted_5, [
                _renderSlot(_ctx.$slots, "selected-prefix", { selected: _ctx.modelValue }, undefined, true)
              ]))
            : _createCommentVNode("", true),
          _createVNode("input", {
            id: _ctx.id,
            ref: "selectSearch",
            value: _ctx.filterSearch,
            onFocus: _cache[1] || (_cache[1] = 
//@ts-ignore
(...args) => (_ctx.onFocus && _ctx.onFocus(...args))),
            onBlur: _cache[2] || (_cache[2] = 
//@ts-ignore
(...args) => (_ctx.onBlur && _ctx.onBlur(...args))),
            onInput: _cache[3] || (_cache[3] = 
//@ts-ignore
(...args) => (_ctx.onSearch && _ctx.onSearch(...args))),
            placeholder: _ctx.placeholder,
            class: 
              `flex-shrink w-full bg-white rounded-md leading-tight font-normal focus:outline-none ${
                _ctx.isDisabled
                  ? 'text-gray-lp-600 cursor-not-allowed'
                  : 'text-black-lp-300'
              } ${_ctx.disabledBackground ? 'bg-gray-lp-1500' : ''} ${_ctx.inputStyling}`
            ,
            disabled: _ctx.isDisabled,
            autocomplete: "nope",
            onKeydown: _cache[4] || (_cache[4] = 
//@ts-ignore
(...args) => (_ctx.onKeyDown && _ctx.onKeyDown(...args))),
            maxlength: _ctx.maxLength
          }, null, 42, ["id", "value", "placeholder", "disabled", "maxlength"]),
          (_ctx.$slots['selected-info'])
            ? (_openBlock(), _createBlock("div", _hoisted_6, [
                _renderSlot(_ctx.$slots, "selected-info", { selected: _ctx.modelValue }, undefined, true)
              ]))
            : _createCommentVNode("", true),
          (_ctx.isViewAll)
            ? (_openBlock(), _createBlock("button", {
                key: 3,
                disabled: _ctx.isDisabled,
                type: "button",
                class: "text-14px text-red-lp-100 cursor-pointer whitespace-nowrap pl-2",
                onClick: _cache[5] || (_cache[5] = 
//@ts-ignore
(...args) => (_ctx.clickViewAll && _ctx.clickViewAll(...args)))
              }, _toDisplayString(_ctx.$t("bookingV3.commodityViewAll")), 9, ["disabled"]))
            : _createCommentVNode("", true),
          (!_ctx.isDisabled && _ctx.openIcon && _ctx.closeIcon && !_ctx.isViewAll)
            ? (_openBlock(), _createBlock("div", {
                key: 4,
                class: "absolute inset-y-0 right-0 flex items-center",
                style: {"cursor":"pointer"},
                onClick: _cache[8] || (_cache[8] = 
              () => (_ctx.isOpenMenu ? _ctx.closeSelect() : _ctx.$refs.selectSearch?.focus())
            )
              }, [
                (_ctx.filterSearch)
                  ? (_openBlock(), _createBlock(_component_Icons, {
                      key: 0,
                      name: "icon-x",
                      width: "24",
                      height: "24",
                      class: "w-4 text-gray-lp-600",
                      onClick: _withModifiers(_ctx.clearSelect, ["stop"])
                    }, null, 8, ["onClick"]))
                  : (_openBlock(), _createBlock("div", _hoisted_7, [
                      (_ctx.isOpenMenu)
                        ? (_openBlock(), _createBlock("img", {
                            key: 0,
                            src: require(`@/app/ui/assets/svg/${_ctx.openIcon}.svg`),
                            class: "w-4",
                            alt: "open",
                            onClick: _cache[6] || (_cache[6] = () => _ctx.$emit('chevron', true))
                          }, null, 8, ["src"]))
                        : (_openBlock(), _createBlock("img", {
                            key: 1,
                            src: require(`@/app/ui/assets/svg/${_ctx.closeIcon}.svg`),
                            class: "w-4",
                            alt: "close",
                            onClick: _cache[7] || (_cache[7] = 
                  () => {
                    _ctx.$emit('chevron', true);
                    _ctx.isChevron = true;
                  }
                )
                          }, null, 8, ["src"]))
                    ]))
              ]))
            : _createCommentVNode("", true)
        ], 2)
      ])
    ], 2),
    _withDirectives(_createVNode("div", {
      id: "dropdown-content",
      style: _ctx.styleDropDown,
      class: "w-full z-30 bg-white absolute border border-t-0 border-gray-lp-400 pr-1 rounded-b-md"
    }, [
      _createVNode("div", {
        id: "infinite-list",
        ref: "container",
        onScrollend: _cache[9] || (_cache[9] = _withModifiers(
//@ts-ignore
(...args) => (_ctx.fetchNew && _ctx.fetchNew(...args)), ["prevent"])),
        class: "select overflow-auto",
        style: { maxHeight: _ctx.maxHeight }
      }, [
        (_openBlock(true), _createBlock(_Fragment, null, _renderList(_ctx.dataOptions, (item, index) => {
          return (_openBlock(), _createBlock("div", {
            key: index,
            ref: `option${index}`,
            class: 
            `cursor-pointer flex flex-row items-center px-4 py-1 hover:bg-gray-lp-700 ${index ===
              _ctx.dataOptions.length - 1 && 'pb-2'} ${
              _ctx.isSelected(item) ? 'text-red-lp-100' : 'text-black-lp-200'
            }`
          ,
            onMousedown: ($event: any) => (_ctx.onChooseSelect(item))
          }, [
            (_ctx.$slots['custom-option'])
              ? _renderSlot(_ctx.$slots, "custom-option", {
                  key: 0,
                  item: item
                }, undefined, true)
              : (_openBlock(), _createBlock(_Fragment, { key: 1 }, [
                  _createVNode("span", {
                    class: `flex-grow ${_ctx.secondKeyName && `truncate pr-1`}`
                  }, _toDisplayString(item[_ctx.keyName] || item), 3),
                  (_ctx.secondKeyName && item[_ctx.secondKeyName])
                    ? (_openBlock(), _createBlock("span", _hoisted_8, _toDisplayString(item[_ctx.secondKeyName]), 1))
                    : _createCommentVNode("", true)
                ], 64))
          ], 42, ["onMousedown"]))
        }), 128)),
        _withDirectives(_createVNode("div", _hoisted_9, [
          _createVNode(_component_Skeleton, {
            height: "1.3rem",
            width: "88%",
            class: "my-2"
          }),
          _createVNode(_component_Skeleton, {
            height: "1.3rem",
            width: "94%",
            class: "my-2"
          }),
          _createVNode(_component_Skeleton, {
            height: "1.3rem",
            width: "83%",
            class: "my-2"
          }),
          _createVNode(_component_Skeleton, {
            height: "1.3rem",
            width: "97%",
            class: "my-2"
          })
        ], 512), [
          [_vShow, _ctx.isLoading]
        ])
      ], 36),
      (_ctx.dataOptions.length === 0 && _ctx.isShowErrorMessage && !_ctx.isLoading)
        ? (_openBlock(), _createBlock("div", _hoisted_10, [
            (_ctx.isShowIconEmpty)
              ? (_openBlock(), _createBlock("img", _hoisted_11))
              : (_openBlock(), _createBlock("p", _hoisted_12, _toDisplayString(_ctx.$t(_ctx.errorMessage)), 1))
          ]))
        : _createCommentVNode("", true),
      (_ctx.addDriver || _ctx.addLicensePlate)
        ? (_openBlock(), _createBlock("div", _hoisted_13, [
            _withDirectives(_createVNode("div", null, [
              _createVNode("button", {
                onClick: _cache[10] || (_cache[10] = ($event: any) => (_ctx.handleOpenPlus(true))),
                style: {"border-color":"#d4d5d8"},
                class: "border rounded-lg py-2 px-3 text-black-lp-300 cursor-pointer focus:outline-none"
              }, [
                _createVNode("span", _hoisted_14, [
                  _hoisted_15,
                  _createTextVNode(" " + _toDisplayString(_ctx.addDriver
                  ? _ctx.$t("Tambah Driver")
                  : _ctx.$t("Tambah No. Seri Kendaraan")), 1)
                ])
              ])
            ], 512), [
              [_vShow, !_ctx.openPlus]
            ]),
            _withDirectives(_createVNode("div", null, [
              (_ctx.addDriver)
                ? (_openBlock(), _createBlock(_Fragment, { key: 0 }, [
                    _createVNode("div", _hoisted_16, [
                      _createVNode("div", _hoisted_17, _toDisplayString(_ctx.$t("Nama Driver")), 1),
                      _withDirectives(_createVNode("input", {
                        onInput: _cache[11] || (_cache[11] = 
//@ts-ignore
(...args) => (_ctx.filterInputDriverName && _ctx.filterInputDriverName(...args))),
                        "onUpdate:modelValue": _cache[12] || (_cache[12] = ($event: any) => (_ctx.driver.name = $event)),
                        class: "text-gray-lp-500 w-6/12 p-1.5 bg-white border border-gray-lp-400 rounded shadow-xs leading-tight focus:outline-none",
                        placeholder: _ctx.$t('Masukan nama driver'),
                        type: "text"
                      }, null, 40, ["placeholder"]), [
                        [_vModelText, _ctx.driver.name]
                      ]),
                      _createVNode("div", _hoisted_18, [
                        _createVNode("img", {
                          onClick: _cache[13] || (_cache[13] = 
//@ts-ignore
(...args) => (_ctx.clearDriverForm && _ctx.clearDriverForm(...args))),
                          class: "cursor-pointer mx-3",
                          style: {"height":"20px","width":"20px"},
                          src: _imports_3,
                          alt: "x-circle-outline"
                        }),
                        _createVNode("img", {
                          onClick: _cache[14] || (_cache[14] = 
//@ts-ignore
(...args) => (_ctx.submitDriver && _ctx.submitDriver(...args))),
                          class: "cursor-pointer",
                          style: {"height":"20px","width":"20px"},
                          src: _imports_4,
                          alt: "check-circle-border-green"
                        })
                      ])
                    ]),
                    _createVNode("div", _hoisted_19, [
                      _createVNode("div", _hoisted_20, _toDisplayString(_ctx.$t("No. Telp Driver")), 1),
                      _withDirectives(_createVNode("input", {
                        onInput: _cache[15] || (_cache[15] = 
//@ts-ignore
(...args) => (_ctx.filterInputDriverPhone && _ctx.filterInputDriverPhone(...args))),
                        "onUpdate:modelValue": _cache[16] || (_cache[16] = ($event: any) => (_ctx.driver.phone = $event)),
                        class: "text-gray-lp-500 w-6/12 p-1.5 bg-white border border-gray-lp-400 rounded shadow-xs leading-tight focus:outline-none",
                        placeholder: _ctx.$t('Masukan no. telp driver'),
                        type: "text"
                      }, null, 40, ["placeholder"]), [
                        [_vModelText, _ctx.driver.phone]
                      ]),
                      _hoisted_21
                    ])
                  ], 64))
                : _createCommentVNode("", true),
              (_ctx.addLicensePlate)
                ? (_openBlock(), _createBlock("div", _hoisted_22, [
                    _createVNode("span", _hoisted_23, _toDisplayString(_ctx.$t("No. Seri")), 1),
                    _withDirectives(_createVNode("input", {
                      onInput: _cache[17] || (_cache[17] = 
//@ts-ignore
(...args) => (_ctx.filterInputLicensePlate && _ctx.filterInputLicensePlate(...args))),
                      "onUpdate:modelValue": _cache[18] || (_cache[18] = ($event: any) => (_ctx.licensePlate = $event)),
                      class: "text-gray-lp-500 w-7/12 p-1.5 bg-white border border-gray-lp-400 rounded shadow-xs leading-tight focus:outline-none",
                      placeholder: _ctx.$t('Masukan No. seri kendaraan'),
                      type: "text"
                    }, null, 40, ["placeholder"]), [
                      [_vModelText, _ctx.licensePlate]
                    ]),
                    _createVNode("div", _hoisted_24, [
                      _createVNode("img", {
                        onClick: _cache[19] || (_cache[19] = 
//@ts-ignore
(...args) => (_ctx.clearLicensePlateForm && _ctx.clearLicensePlateForm(...args))),
                        class: "cursor-pointer",
                        style: {"height":"20px","width":"20px"},
                        src: _imports_3,
                        alt: "x-circle-outline"
                      }),
                      _createVNode("img", {
                        onClick: _cache[20] || (_cache[20] = 
//@ts-ignore
(...args) => (_ctx.submitLicensePlate && _ctx.submitLicensePlate(...args))),
                        class: "cursor-pointer",
                        style: {"height":"20px","width":"20px"},
                        src: _imports_4,
                        alt: "check-circle-border-green"
                      })
                    ])
                  ]))
                : _createCommentVNode("", true)
            ], 512), [
              [_vShow, _ctx.openPlus]
            ])
          ]))
        : _createCommentVNode("", true),
      (_ctx.addAccountNumber)
        ? (_openBlock(), _createBlock("div", _hoisted_25, [
            (_ctx.dataOptions.length === 0)
              ? (_openBlock(), _createBlock("button", {
                  key: 0,
                  onClick: _cache[21] || (_cache[21] = 
//@ts-ignore
(...args) => (_ctx.handleOpenEditBeneficiaryAccount && _ctx.handleOpenEditBeneficiaryAccount(...args))),
                  style: {"border-color":"#d4d5d8"},
                  class: "border rounded-lg py-2 px-3 text-black-lp-300 cursor-pointer focus:outline-none"
                }, [
                  _hoisted_26
                ]))
              : (_openBlock(), _createBlock("button", {
                  key: 1,
                  onClick: _cache[22] || (_cache[22] = 
//@ts-ignore
(...args) => (_ctx.handleOpenEditBeneficiaryAccount && _ctx.handleOpenEditBeneficiaryAccount(...args))),
                  style: {"border-color":"#d4d5d8"},
                  class: "border rounded-lg py-2 px-3 text-black-lp-300 cursor-pointer focus:outline-none"
                }, [
                  _hoisted_27
                ]))
          ]))
        : _createCommentVNode("", true),
      _renderSlot(_ctx.$slots, "footer-select", {}, undefined, true)
    ], 4), [
      [_vShow, _ctx.isOpenMenu && !_ctx.isDisabled]
    ]),
    (
        _ctx.dataOptions.length === 0 &&
          !_ctx.isShowErrorMessage &&
          _ctx.filterSearch &&
          !_ctx.isDisabled &&
          !_ctx.isFirstLanding
      )
      ? (_openBlock(), _createBlock("p", _hoisted_28, _toDisplayString(_ctx.$t("Data tidak ditemukan")), 1))
      : _createCommentVNode("", true),
    _withDirectives(_createVNode("div", {
      class: 
        !!_ctx.errorCaption
          ? 'text-red-lp-100 text-12px xxl:text-14px pl-1 py-2 flex gap-x-2'
          : ''
      
    }, [
      (!_ctx.hideErrorIcon && !!_ctx.errorCaption)
        ? (_openBlock(), _createBlock("img", _hoisted_29))
        : _createCommentVNode("", true),
      _createTextVNode(" " + _toDisplayString(_ctx.$t(_ctx.errorCaption)), 1)
    ], 2), [
      [_vShow, _ctx.isShowErrorIndicator]
    ]),
    (_ctx.isError)
      ? (_openBlock(), _createBlock(_component_ErrorMessage, {
          key: 2,
          onCancel: _ctx.handleErrorClose,
          errorType: _ctx.errorCause,
          modal: ""
        }, null, 8, ["onCancel", "errorType"]))
      : _createCommentVNode("", true)
  ], 10, ["id"])), [
    [_directive_click_outside, 
      () => {
        if (_ctx.isChevron) {
          _ctx.$refs.selectSearch?.focus();
          _ctx.isChevron = false;
        } else if (_ctx.isOpenMenu) {
          _ctx.closeSelect();
        }
      }
    ]
  ])
})